<template>
  <div :data-category="block.category" class="content-block bg-neutral-50 p-6 rounded-lg shadow-md">
    <div class="flex items-center space-x-2 mb-2">
      <!-- Competitor Logo matching the sidebar design -->
      <div
        :class="[
          'w-8 h-8 rounded-full flex items-center justify-center',
          competitorInfo ? competitorInfo.backgroundColor : block.logoBgColor,
          competitorInfo ? competitorInfo.textColor : block.logoTextColor
        ]"
      >
        {{ competitorInfo ? competitorInfo.abbreviation : block.initials }}
      </div>
      <div>
        <span class="text-xl font-semibold">{{ block.companyName }}</span>
        <button class="bg-violet-700 text-white px-4 py-2 ml-5 rounded cursor-default">
          {{ block.incent }}
        </button>
        <button
          v-for="(tag, index) in block.tags"
          :key="index"
          class="bg-violet-200 text-black px-4 py-2 ml-2 rounded cursor-default"
        >
          {{ tag }}
        </button>
      </div>
    </div>
    <div class="text-2xl font-bold mb-4">{{ block.title }}</div>
    <div class="flex space-x-4 mb-4 grid grid-cols-1 md:grid-cols-4">
      <img
        v-for="(image, index) in block.images"
        :key="index"
        :src="image.src"
        @error="image.error = true; image.src = image.fallback"
        :alt="image.alt || 'Fallback image'"
        class="w-72 h-44 object-cover rounded-lg shadow-md cursor-default"
      />
      <div class="bg-white p-6 rounded-lg shadow text-left col-span-2">
        <h3 class="text-lg mb-2">
          Subject: <span class="font-bold">{{ block.reference }}</span>
        </h3>
        <h3 class="text-lg mb-2">
          Date: <span class="font-bold">{{ formatDate(block.date) }}</span>
        </h3>
        <h3 class="text-lg mb-2">
          Category: <span class="font-bold">{{ block.collection }}</span>
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useMainStore } from "../stores/useMainStore";

export default {
  props: {
    block: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const mainStore = useMainStore();

    // Find competitor info using the lower-case, no-space version of the company name.
    const competitorInfo = computed(() => {
      return mainStore.sidebarItems.find((item) => {
        return item.name && item.name.toLowerCase().replace(/\s/g, "") === props.block.category;
      });
    });

    const openFullView = (imageSrc) => {
      mainStore.openFullView(imageSrc);
    };

    return {
      openFullView,
      competitorInfo,
    };
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      return `${day}.${month}.${year} at ${hours}:${minutes}`;
    },
  },
};
</script>
